import { IconType, SvgIcon } from './SvgIcon';

export const InfoIconFilled: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 21 21">
    <path
      d="M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20ZM10 5C10.6 5 11 5.4 11 6C11 6.6 10.6 7 10 7C9.4 7 9 6.6 9 6C9 5.4 9.4 5 10 5ZM9 10C9 9.4 9.4 9 10 9C10.6 9 11 9.4 11 10V14C11 14.6 10.6 15 10 15C9.4 15 9 14.6 9 14V10Z"
      fill="currentColor"
    />
  </SvgIcon>
);

InfoIconFilled.displayName = 'InfoIconFilled';
